import React from 'react';

const Hamburger = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
  </svg>
);

export default Hamburger;
